// src/stores/locarion.js
import { defineStore } from "pinia";
import { httpRequest } from "@/services/api";
import { showAlert } from "@/composables/useAlert";

export const useBrandStore = defineStore("brand", {
  state: () => ({
    allBrands: [],
    brandModels: [],
    isLoading: false,
  }),

  actions: {
    async getAllBrands() {
      this.isLoading = true;
      try {
        const res = await httpRequest(`/brands?pageSize=-1`, { method: "GET" });
        this.allBrands = res.data || [];
      } catch (error) {
        showAlert(
          error.response?.data?.message || "حدث خطأ أثناء جلب البيانات",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
    async getBrandModels(brandId) {
      this.isLoading = true;
      try {
        const res = await httpRequest(`/models?pageSize=-1&brand_id=${brandId}`, { method: "GET" });
        this.brandModels = res.data || [];
      } catch (error) {
        showAlert(
          error.response?.data?.message || "حدث خطأ أثناء جلب البيانات",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
});
